module.exports = __webpack_public_path__ + "static/media/PaketF.e017d307.jpeg";